/**
 * using parseFloat here so we can
 * @param stringVal
 * @returns
 */
export const convertStringToNumber = (stringVal: string): number => parseFloat(stringVal);

export default convertStringToNumber;
